import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '@/utils/element-ui.js'
import '@/assets/styles/common.less'
import TabBar from '@/components/tabBar.vue'
import MyPropagandize from '@/components/propagandize.vue'
import MyChart from '@/components/chart.vue'
import LoginComponent from '@/components/logincomponent.vue'
import NewsCarousel from '@/components/newscarousel.vue'
import SortTool from '@/components/sorttool.vue'
import MyFooter from '@/components/footer.vue'
import GoodsComponent from '@/components/goods.vue'
import UcGoods from '@/components/ucgoods.vue'
import UCGossip from '@/components/ucgossip.vue'
import ShowImage from '@/components/image.vue'
import GossipImage from '@/components/gossipimage.vue'
import RentImage from '@/components/rentimage.vue'
import CommercialMemberImage from '@/components/commercialmemberimage.vue'
import OutfitImage from '@/components/outfitimage.vue'
import UCTask from '@/components/uctask.vue'
import UCRent from '@/components/ucrent.vue'
import UCGameData from '@/components/ucgamedata.vue'
import MXNumTag from '@/components/mxnumtag.vue'
import MXStrTag from '@/components/mxstrtag.vue'
import MXDigitTag from '@/components/mxdigittag.vue'
import ContactBox from '@/components/contactbox.vue'
import CommentBox from '@/components/commentbox.vue'
import CallAgent from '@/components/callagent.vue'
import TaskItem from '@/components/taskitem.vue'
import GroupQR from '@/components/groupQR.vue'
Vue.config.productionTip = false
Vue.component(TabBar.name, TabBar)
Vue.component(MyPropagandize.name, MyPropagandize)
Vue.component(MyChart.name, MyChart)
Vue.component(LoginComponent.name, LoginComponent)
Vue.component(NewsCarousel.name, NewsCarousel)
Vue.component(SortTool.name, SortTool)
Vue.component(MyFooter.name, MyFooter)
Vue.component(GoodsComponent.name, GoodsComponent)
Vue.component(UcGoods.name, UcGoods)
Vue.component(ShowImage.name, ShowImage)
Vue.component(UCGossip.name, UCGossip)
Vue.component(GossipImage.name, GossipImage)
Vue.component(UCTask.name, UCTask)
Vue.component(UCRent.name, UCRent)
Vue.component(RentImage.name, RentImage)
Vue.component(UCGameData.name, UCGameData)
Vue.component(CommercialMemberImage.name, CommercialMemberImage)
Vue.component(OutfitImage.name, OutfitImage)
Vue.component(MXNumTag.name, MXNumTag)
Vue.component(MXStrTag.name, MXStrTag)
Vue.component(MXDigitTag.name, MXDigitTag)
Vue.component(ContactBox.name, ContactBox)
Vue.component(CommentBox.name, CommentBox)
Vue.component(CallAgent.name, CallAgent)
Vue.component(TaskItem.name, TaskItem)
Vue.component(GroupQR.name, GroupQR)
Vue.prototype.$profession = [
  { id: 0, type: '无' },
  { id: 1, type: '法师' },
  { id: 2, type: '战士' },
  { id: 3, type: '异能' },
  { id: 4, type: '血族' },
  { id: 5, type: '亡灵' },
  { id: 6, type: '龙骑' },
  { id: 7, type: '精灵' },
  { id: 8, type: '御剑' },
  { id: 9, type: '神子' },
  { id: 10, type: '千面' },
  { id: 11, type: '多职业号' }
]
Vue.prototype.$part = [
  { id: 0, type: '无' },
  { id: 1, type: '头盔' },
  { id: 2, type: '项链' },
  { id: 3, type: '衣服' },
  { id: 4, type: '武器' },
  { id: 5, type: '手镯' },
  { id: 6, type: '鞋子' }
]
Vue.prototype.$eqType = [
  { id: '0', type: '单件' },
  { id: '1', type: '整套' }
]
Vue.directive('focus', {
  inserted: function (el) {
    el.focus()
  }
})
new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
